<template>
  <li
    class="md-list-item md-list-item-expand"
    :class="{
      'md-disabled': disabled,
      'md-active': active,
    }"
    ref="rootCmp"
  >
    <div class="md-list-item-container md-button">
      <slot></slot>

      <md-icon class="md-list-expand-indicator" :mdSvg="mdiChevronDown" />
      <md-button
        :id="id"
        type="button"
        class="md-button-ghost"
        :aria-label="buttonAriaLabel"
        @click.stop.self="toggleExpandList"
        :disabled="disabled || null"
      ></md-button>
    </div>
    <div class="md-list-expand" ref="expandCmp">
      <slot name="expand"></slot>
    </div>
  </li>
</template>

<script lang="ts" setup>
import { ref, inject, onMounted, nextTick, onUnmounted } from 'vue';
import { mdiChevronDown } from '@mdi/js';
const props = withDefaults(
  defineProps<{
    id?: string;
    disabled?: boolean;
    mdExpandMultiple?: boolean;
    buttonAriaLabel?: string;
  }>(),
  {
    disabled: false,
    mdExpandMultiple: false,
  }
);

const emit = defineEmits(['click']);
const parentList = inject<string>('mdList');

const expandCmp = ref(null);
const rootCmp = ref(null);

const active = ref(false);

const sharedInfo = {
  inactivate: () => (active.value = false),
};

function resetSiblings() {
  parentList?.getExpandedList().forEach((child) => {
    if (child !== sharedInfo && child.inactivate) {
      child.inactivate();
    }
  });
}

function toggleExpandList($event) {
  if (!props.mdExpandMultiple) {
    resetSiblings();
  }
  active.value = !active.value;
  emit('click', $event);
}

onMounted(() => {
  nextTick(() => {
    parentList.registerExpanded(sharedInfo);
  });
});
onUnmounted(() => {
  parentList.removeExpanded(sharedInfo);
});
</script>
